import { t } from '@lingui/core/macro';

import EuBadge from '@rover/icons/svg/eu-badge.svg';
import UsBadge from '@rover/icons/svg/us-badge.svg';

export type Props = {
  isInEurope?: boolean;
  isInline?: boolean; // Inline means inserted into search results
};

export const getBannerText = (isInEurope?: boolean): string => {
  return isInEurope
    ? t`We <0>ID verify</0> our sitters.`
    : t`We <0>background check</0> every sitter.`;
};

export const getBadge = (isInEurope?: boolean, isInline?: boolean): JSX.Element => {
  const isInlineKey = isInline ? 'inline' : 'top';
  const badgeSizing = {
    EU: {
      top: {
        width: 24,
        height: 24,
      },
      inline: {
        width: 32,
        height: 32,
      },
    },
    US: {
      top: {
        width: 41,
        height: 32,
      },
      inline: {
        width: 51.25,
        height: 40,
      },
    },
  };
  return isInEurope ? (
    <EuBadge {...badgeSizing.EU[isInlineKey]} data-testid="background-check-eu-badge" />
  ) : (
    <UsBadge {...badgeSizing.US[isInlineKey]} data-testid="background-check-us-badge" />
  );
};
